export const formFilterKeys = {
    errorType: "error-code",
    statusCode: "status-code",
    period: "period",
    documentId: "documentId",
    municipalities: "municipalities",
    ssn: "ssn",
    onlyFormsWithError: "only-forms-with-error"
};
